import { useEffect, useRef, useState } from 'react'
import { RefreshCw, Trash2 } from 'lucide-react'
import type { UploadBridge } from '@/features/editor/lib/uploadBridge'
import { useMessages } from '@/i18n'
import { CanvasBridgeProgress } from './canvasVideoDrop'
import { QBtn } from './design/quickToolbarParts'
import { messages } from './design/messages'

/**
 * Картинка на весь экран на холсте: нажатие показывает ту же плашку «Заменить / Удалить»,
 * что у картинки составного блока. Выбор файла и запись — у зоны в панели (`bridge`).
 */
export const CanvasImageActions = ({ bridge }: { bridge: UploadBridge }) => {
  const m = useMessages(messages)
  const [open, setOpen] = useState(false)
  const rootRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!open) return
    const closeOutside = (e: PointerEvent) => {
      if (!rootRef.current?.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('pointerdown', closeOutside)
    return () => document.removeEventListener('pointerdown', closeOutside)
  }, [open])
  const act = (action: () => void) => {
    setOpen(false)
    action()
  }
  return (
    // `relative z-10`: иначе полноэкранная картинка лежит поверх и забирает нажатия.
    <div
      ref={rootRef}
      data-testid="canvas-image-actions"
      className="relative z-10 flex-1 cursor-pointer"
      onClick={() => setOpen((was) => !was)}
    >
      <CanvasBridgeProgress bridge={bridge} />
      {open ? (
        <div
          onClick={(e) => e.stopPropagation()}
          className="absolute bottom-3 left-1/2 flex -translate-x-1/2 cursor-default items-center gap-0.5 whitespace-nowrap rounded-xl bg-popover/95 p-1 text-popover-foreground shadow-xl ring-1 ring-border backdrop-blur duration-150 animate-in fade-in"
        >
          <QBtn title={m.replaceImage} onClick={() => act(() => bridge.request(null))}>
            <RefreshCw className="size-4" />
            <span className="ml-1.5">{m.replace}</span>
          </QBtn>
          <QBtn title={m.removeImage} onClick={() => act(bridge.requestRemove)}>
            <Trash2 className="size-4" />
            <span className="ml-1.5">{m.remove}</span>
          </QBtn>
        </div>
      ) : null}
    </div>
  )
}
